import { Component, OnInit, ViewChild } from '@angular/core';
import { OrganizationInfo } from '../model/organization';
import { RegistrationService } from '../services/registration.servcie';
import { ProgramComponent } from '../program/program.component';
import { Program } from "src/app/model/program";
import { ApplicationComponent } from "src/app/application/application.component";
import { ReviewComponent } from "src/app/review/review.component";
import { OperationHour } from "src/app/model/operationHour";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { OrganizationFiles } from '../model/organizationfiles';
import { NgZone } from "@angular/core";
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from '../services/navigation-gaurd.service';
import { CommonService } from "src/app/services/common.service";

declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: [
    './registration.component.css'
    ]
})
export class RegistrationComponent implements OnInit, CanComponentDeactivate {

  @ViewChild('applicationCtrl')
  public applicationComponent: ApplicationComponent;

  @ViewChild('programCtrl')
  public programComponent: ProgramComponent;

  @ViewChild('reviewCtrl')
  public reviewComponent: ReviewComponent;



  public organizationInfo: OrganizationInfo;
  public program: Program;
  public operationHour: OperationHour;
  public registrationWorkflow: any;
  public agencyGuid : string = '';
public operationHours: OperationHour[];
public organizationFiles: OrganizationFiles;
public reqErrMssages: any[];
  constructor(private readonly _registrationService: RegistrationService,
   private readonly _router: Router,
   private _ngZone: NgZone,
   private _commonService: CommonService,
   private readonly _activatedRoute: ActivatedRoute) {
    
   
    this.organizationInfo = {
      OrganizationGuid: '',
      OrganizationName: '',
      ContactPersonName: '',
      ContactPersonEmailAddress: '',
      ContactPersonPhone: '',
      PublicEmail: '',
      Phone: '',
      Street: '',
      City: '',
      State: '',
      Zip: '',
      Country: '',
      URL: '',
      Hours: '',
      Type: '',
      FoundedOn: '',
      LicNo: '',
      MissionStatement: '',
      EIN: '',
      IsCourtAppointedServicesAccepted: '',
      IsCommunityServiceCreditQualified: '',
      IsActiveGenralLiabilityPolicy: '',
      IsInsuranceLoaded: false,
      LogoFileName: '',
      IsLogoUploaded: false,
      InsuranceFileName: '',
      InsuranceNumber:'',
      InsuranceCompanyName:'',
      Status:'',
      OperationHours: [],
      Programs: []
  };

  

 
  }

  public GetRegistrationDetails(orgGuid){
    let that = this;
    this._registrationService.getRegistrationDetails(orgGuid).subscribe((result) => {
          console.log(result);
          if(result != undefined && result != 'ERROR') {
            that.organizationInfo =JSON.parse(result) ;
            this._registrationService.getOrganizationFileUrls(orgGuid).subscribe((filesresult) => {
              console.log(filesresult);
              if(filesresult != undefined && filesresult != 'ERROR') {
                  that.organizationFiles = filesresult;
              }
    
            }, (fileserr) => {
              console.log(fileserr);
            });
    
          } else {
          }
          
        }, (err) => {
          console.log(err);
        });
    }


canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if( this.applicationComponent != undefined && 
    this.applicationComponent.registrationForm != undefined && 
    this.applicationComponent.registrationForm.dirty &&
    this.programComponent != undefined && 
    this.programComponent.programForm != undefined && 
    this.programComponent.programForm.dirty ) { 
      return confirm('Form has unsaved changes.' + 
      ' Any Data entered will be lost. Do you want to leave?');
    } else {
      return true;
    }
   }

  ngOnInit() {
    $('#dvReqMessage').modal('show');
    //  $('#dvterms').modal('show');
    this.subscribeToResetForm();
   //this.applicationComponent.InitilaizeComponent();

    this.PopulateWorkingHours();
   this.AddProgram();
   //this.applicationComponent.InitilaizeComponent();
   let that = this;
   this._activatedRoute.params.subscribe((params: Params) => {
    let guid: string = params['organizationguid'];
    if(guid != undefined && guid != '') {
     
      setTimeout(() => {
      that.GetRegistrationDetails(guid);
    }, 300);
    }
});
  }

public ShowTerms() {
   $('#dvReqMessage').modal('hide');
   $('#dvterms').modal('show');
}
public Agree () {
  $('#dvterms').modal('hide');
  //$('#dvReqMessage').modal('show');
  
}

public DisAgree () {
  $('#dvterms').modal('hide');
this._router.navigate(['/app-home']);
//this._router.navigateByUrl('/');
//location.reload();
}
  public selectFile(event) {
    console.log(event);
  }

public Previous () {

}

public getWidth()
    {
       if ( this.isReadyToSubmit() ) {
            return '100%';
       } else if(this.isReadyToAddProgram()) {
            return '50%';
      } else {
        return '25%';
      }
   }

public AddProgram() {
  this.organizationInfo.Programs.push(new Program());
}
public PopulateWorkingHours() {

  this.operationHours= [];
  var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  for (let i = 0; i < days.length ; i++) {

    let operationHour: OperationHour = {      
      Day: days[i], DayCode: '', StartTime: '', EndTime: '', IsSelected: false
    }
    this.operationHours.push(operationHour);
  }
  this.organizationInfo.OperationHours = this.operationHours;
}

  public saveAgencyDetails () {
    this._registrationService.newRegistration(this.organizationInfo).subscribe((result) => {
      console.log(result);
      // this.router.navigate(['/product-details/'+result._id]);
    }, (err) => {
      console.log(err);
    });
  }


public ApplicationRequiredErrorMessages() {
 //return true;
 let errorlist = []
  if (this.organizationInfo.OrganizationName == '') {
  errorlist.push('Organization Name is required.');
  }
  if (this.organizationInfo.Street == '') {
  errorlist.push('Street Address is required.');
  }
  if (this.organizationInfo.City == '') {
  errorlist.push('City is required.');
  }
  if (this.organizationInfo.State == '') {
  errorlist.push('State is required.');
  }   
  if (this.organizationInfo.Zip == '') {
  errorlist.push('Zip is required.');
  }        
  if (this.organizationInfo.URL == '') {
  errorlist.push('Website URL is required.');
  } 
  if (this.organizationInfo.PublicEmail == '') {
  errorlist.push('Email Address is required.');
} 
if (this.organizationInfo.PublicEmail != '') {
  if(!this.onEmailValidate(this.organizationInfo.PublicEmail)) {
    errorlist.push('Email Address is not valid.');
  }  
} 
  if (this.organizationInfo.Phone == '') {
  errorlist.push('Phone Number is required.');
  }      
   if (this.organizationInfo.Phone.length != 12) {
  errorlist.push('Phone Number should be 10 digits.');
  }       
  if (this.organizationInfo.ContactPersonName == '') {
  errorlist.push('Contact Person Name is required.');
  }     
  if (this.organizationInfo.ContactPersonEmailAddress == '') {
  errorlist.push('Contact Person Email Address is required.');
}  
if (this.organizationInfo.ContactPersonEmailAddress != '') {
  if(!this.onEmailValidate(this.organizationInfo.ContactPersonEmailAddress)) {
    errorlist.push('Contact Person Email Address is not valid.');
  }  
}     
  if (this.organizationInfo.ContactPersonPhone == '') {
  errorlist.push('Contact Person Phone is required.');
  }      
  if (this.organizationInfo.ContactPersonPhone.length != 12) {
  errorlist.push('Contact Person Phone should be 10 digits.');
  }     
  if (this.organizationInfo.IsActiveGenralLiabilityPolicy == '') {
  errorlist.push('Does your community-based organization have an active general liability insurance policy?');
  }        
    if (this.organizationInfo.IsCommunityServiceCreditQualified == '') {
  errorlist.push('Does your community-based organization qualify for community service credit?');
}  
 if (this.organizationInfo.IsCourtAppointedServicesAccepted == '') {
  errorlist.push('Does your community-based organization accept court appointed services?');
  }        
 if (this.organizationInfo.MissionStatement == '') {
  errorlist.push('MissionStatement is required.');
}  
if (this.organizationInfo.OperationHours.filter(x=>x.IsSelected).length == 0) {
  errorlist.push('OperationHours is required.');
}  
 if (this.organizationInfo.Type == '') {
  errorlist.push('Organization Type  is required.');
} 
if (this.organizationInfo.Type == 'Non-Profit' || this.organizationInfo.Type == 'For-profit') {

  if (this.organizationInfo.EIN == '') {
    errorlist.push('EIN is required.');
  } 
  if (this.organizationInfo.InsuranceNumber == '') {
    errorlist.push('Insurance Number is required.');
  } 
  if (this.organizationInfo.InsuranceCompanyName == '') {
    errorlist.push('Insurance Company Name is required.');
    } 
  if(this.applicationComponent.getFoundedOnDate()  == '' || this.applicationComponent.getFoundedOnDate()  == null ) {
    errorlist.push('If your organization is For-profit or Non-profit, when was your organization founded?');
    } 
}

if (this.organizationInfo.Type == 'For-profit') {

  if (this.organizationInfo.LicNo == '') {
    errorlist.push('If your organization is For-profit, please provide a valid Buisness License number.');
  }
}
       
         
  return    errorlist;     
}

public onEmailValidate(emailaddress:string)
    {
       var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 

      //Update the model after validation to check if the save button has to be disabled or not.
      return re.test(emailaddress) ? true: false;
    }

public isReadyToAddProgram() {
//return true;
    if(  this.organizationInfo.OrganizationName != ''
          && this.organizationInfo.Street != '' 
          && this.organizationInfo.City != ''
          && this.organizationInfo.State != ''
          && this.organizationInfo.Zip != ''
          && this.organizationInfo.URL != ''
          && this.organizationInfo.PublicEmail != ''
          && this.onEmailValidate(this.organizationInfo.PublicEmail)
          && this.organizationInfo.Phone != ''
          && this.organizationInfo.Phone.length == 12
          && this.organizationInfo.ContactPersonName != ''
          && this.organizationInfo.ContactPersonEmailAddress != ''
          && this.onEmailValidate(this.organizationInfo.ContactPersonEmailAddress)
          && this.organizationInfo.ContactPersonPhone != ''
          && this.organizationInfo.ContactPersonPhone.length == 12
          && this.organizationInfo.IsActiveGenralLiabilityPolicy != ''
          && this.organizationInfo.IsCommunityServiceCreditQualified != ''
          && this.organizationInfo.IsCourtAppointedServicesAccepted != ''
          && (this.organizationInfo.Type == 'Government' 
          || (this.organizationInfo.Type == 'Non-Profit' && this.applicationComponent.getFoundedOnDate()  != '' && this.applicationComponent.getFoundedOnDate()  != null && this.organizationInfo.EIN != '' && this.organizationInfo.InsuranceNumber && this.organizationInfo.InsuranceCompanyName)
          || (this.organizationInfo.Type == 'For-profit' && this.applicationComponent.getFoundedOnDate()   != '' && this.applicationComponent.getFoundedOnDate()  != null && this.organizationInfo.LicNo  != '' && this.organizationInfo.EIN != '' && this.organizationInfo.InsuranceNumber && this.organizationInfo.InsuranceCompanyName))
         // && (this.organizationInfo.Type != 'Government' && this.organizationInfo.EIN != '')
          && this.organizationInfo.MissionStatement != ''        
          && this.organizationInfo.OperationHours.filter(x=>x.IsSelected).length > 0         
          )
          {
              return true;
          } else
     return false;
}

public isReadyToSubmit() {
   for(let i = 0; i< this.organizationInfo.Programs.length ; i++)
  {
      if(this.organizationInfo.Programs[i].ProgramName == ''
      || this.organizationInfo.Programs[i].Resources.length == 0
      || this.organizationInfo.Programs[i].Languages.length == 0
      || this.organizationInfo.Programs[i].ContactPersonEmailAddress == ''
      || !this.onEmailValidate(this.organizationInfo.Programs[i].ContactPersonEmailAddress)
      || this.organizationInfo.Programs[i].ContactPersonName == ''
      || this.organizationInfo.Programs[i].ContactPersonPhone.length < 12
      || (this.organizationInfo.Programs[i].FreeOfCharge == ''||
      (this.organizationInfo.Programs[i].FreeOfCharge == 'No' && 
      this.organizationInfo.Programs[i].PaymentType == ''))
      || this.organizationInfo.Programs[i].AgeTypes.length == 0
      || this.organizationInfo.Programs[i].Purpose == ''
      || this.organizationInfo.Programs[i].PopulationType == ''
      || this.organizationInfo.Programs[i].ZipCodes.length == 0){
        return false;
          } 
  }
   return true;          
}

public ProgramnRequiredErrorMessages() {

 let errorlist = []

   for(let i = 0; i< this.organizationInfo.Programs.length ; i++)
  {
    if (this.organizationInfo.Programs[i].ProgramName == '') {
    errorlist.push('Program ' + (i+1) + ': Program Name is required.');
    }
    if (this.organizationInfo.Programs[i].Resources.length == 0) {
    errorlist.push('Program ' + (i+1)+ ': Resource Category is required.');
    }
    if (this.organizationInfo.Programs[i].Languages.length == 0) {
    errorlist.push('Program ' + (i+1) + ': Language(s) offered for this program is required.');
    }
    if (this.organizationInfo.Programs[i].ContactPersonEmailAddress == '') {
    errorlist.push('Programs ' + (i+1) + ': Contact Person Email Address is required.');
  }
  if (this.organizationInfo.Programs[i].ContactPersonEmailAddress != '') {
  if(!this.onEmailValidate(this.organizationInfo.Programs[i].ContactPersonEmailAddress)) {
    errorlist.push('Programs ' + (i+1) + ': Contact Person Email Address is not valid.');
  }  
} 

    if (this.organizationInfo.Programs[i].ContactPersonName == '') {
    errorlist.push('Program ' + (i+1) + ': Contact Person Name is required.');
    }
    if (this.organizationInfo.Programs[i].ContactPersonPhone == '') {
    errorlist.push('Program ' + (i+1) + ': Contact Person Phone is required.');
  }
 if (this.organizationInfo.Programs[i].ContactPersonPhone != '') {
    if (this.organizationInfo.Programs[i].ContactPersonPhone.length != 12) {
    errorlist.push('Program ' + (i+1) + ': Contact Person Phone should be of 10 digit.');
    }
  }
    
    if (this.organizationInfo.Programs[i].ContactPersonPhone == '') {
    errorlist.push('Program ' + (i+1) + ': Contact Person Phone is required.');
    }
    if (this.organizationInfo.Programs[i].FreeOfCharge == '') {
    errorlist.push('Program ' + (i+1) + ': Are services for this program free of charge?');
  }
    if (this.organizationInfo.Programs[i].FreeOfCharge == 'No' && this.organizationInfo.Programs[i].PaymentType == '') {
      errorlist.push('Program ' + (i+1) + ': Payment Type is required.');
    }    
    if (this.organizationInfo.Programs[i].AgeTypes.length == 0) {
    errorlist.push('Program ' + (i+1)+ ': What ages are served for this program?');
    }
    if (this.organizationInfo.Programs[i].Purpose == '') {
    errorlist.push('Program ' + (i+1) + ': Purpose of the program  is required.');
    } 
    if (this.organizationInfo.Programs[i].PopulationType == '') {
    errorlist.push('Program ' + (i+1) + ': What population is served for this program?');
    } 
    if (this.organizationInfo.Programs[i].ZipCodes.length == 0) {
    errorlist.push('Program ' + (i+1) + ': ZipCodes is required.');
    } 
    
      
  }
   return errorlist;
          
}



 public NavigateTab(event, navigateTo: string) {

  if( navigateTo == '#tab1'){
            }
             if( navigateTo == '#tab2'){

               if(!this.isReadyToAddProgram()){
                 this.reqErrMssages =  this.ApplicationRequiredErrorMessages();
                 $('#appReqFields').modal('show');                
                }
               this.applicationComponent.SetDateFields();

               this.programComponent.initialize();
                $('#lnkProgram').tab('show');
            }
             if( navigateTo == '#tab3'){
                if(!this.isReadyToSubmit()){
                 this.reqErrMssages =  this.ProgramnRequiredErrorMessages();
                 $('#appReqFields').modal('show');                
                }
               this.reviewComponent.Initialize();
                $('#lnkReview').tab('show');
               
            }
        }

          public subscribeToResetForm():void {
    let that = this;
    this._commonService.resetFormEvent.subscribe(
      (x)=> {
        this._ngZone.run( ()=> {
      this.programComponent.programForm.form.markAsPristine();
      this.applicationComponent.registrationForm.form.markAsPristine();
        }

        )
      }
    );
  }
}
